import { render, staticRenderFns } from "./PdpaMkt.vue?vue&type=template&id=87dc86da&scoped=true&"
import script from "./PdpaMkt.vue?vue&type=script&lang=js&"
export * from "./PdpaMkt.vue?vue&type=script&lang=js&"
import style0 from "./PdpaMkt.vue?vue&type=style&index=0&id=87dc86da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc86da",
  null
  
)

export default component.exports